/**
 * @generated SignedSource<<c0afd4934929f04a4f51b5e6ca3ba34b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InvoiceFilterButton_project$data = {
  readonly id: string;
  readonly " $fragmentType": "InvoiceFilterButton_project";
};
export type InvoiceFilterButton_project$key = {
  readonly " $data"?: InvoiceFilterButton_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"InvoiceFilterButton_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InvoiceFilterButton_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};

(node as any).hash = "039e698c963209de9dff18bd632f751c";

export default node;
